import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    NewVersionResponse,
    TNewVersionResponse,
} from "../../types/devices/ttr/publishDeviceTypes"

type TStartNewVersionMapper = {
    map: (response: unknown) => TNewVersionResponse
}

export const startNewVersionMapper: TStartNewVersionMapper = {
    /** Maps response from "/start-new-version" endpoint to ts-io defined type */
    map: (response: unknown) =>
        tsIoValidate(NewVersionResponse, response, "startNewVersionMapper"),
}
